var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('logo-header-layout',{attrs:{"align":"center","flex":""}},[_c('payment-process-card',{attrs:{"title":_vm.$t('message.payment.sale-disabled', {status: _vm.status})}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }